<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc">Table of Contents</h1>
<p class="toc"><a href="#/OEBPS/cvi.htm">Cover</a></p>
<p class="toc"><a href="#/OEBPS/pra.htm" id="pra">Praise for Val McDermid’s Lindsay Gordon series</a></p>
<p class="toc"><a href="#/OEBPS/also.htm" id="also">Also by Val McDermid</a></p>
<p class="toc"><a href="#/OEBPS/tp.htm">Title Page</a></p>
<p class="toc"><a href="#/OEBPS/cop.htm">Copyright</a></p>
<p class="toc"><a href="#/OEBPS/int.htm" id="int">Introduction to the Grove Edition</a></p>
<p class="toc1"><a href="#/OEBPS/p1tp.htm" id="p1-tp">Final Edition</a></p>
<p class="toc2"><a href="#/OEBPS/p1ack.htm" id="p1-ack">Acknowledgements</a></p>
<p class="toc2"><a href="#/OEBPS/p1pro.htm" id="p1-pro">Prologue</a></p>
<p class="toc2"><a href="#/OEBPS/p1c01.htm" id="p1-c01">Chapter One</a></p>
<p class="toc2"><a href="#/OEBPS/p1c02.htm" id="p1-c02">Chapter Two</a></p>
<p class="toc2"><a href="#/OEBPS/p1c03.htm" id="p1-c03">Chapter Three</a></p>
<p class="toc2"><a href="#/OEBPS/p1c04.htm" id="p1-c04">Chapter Four</a></p>
<p class="toc2"><a href="#/OEBPS/p1c05.htm" id="p1-c05">Chapter Five</a></p>
<p class="toc2"><a href="#/OEBPS/p1c06.htm" id="p1-c06">Chapter Six</a></p>
<p class="toc2"><a href="#/OEBPS/p1c07.htm" id="p1-c07">Chapter Seven</a></p>
<p class="toc2"><a href="#/OEBPS/p1c08.htm" id="p1-c08">Chapter Eight</a></p>
<p class="toc2"><a href="#/OEBPS/p1c09.htm" id="p1-c09">Chapter Nine</a></p>
<p class="toc2"><a href="#/OEBPS/p1c10.htm" id="p1-c10">Chapter Ten</a></p>
<p class="toc2"><a href="#/OEBPS/p1c11.htm" id="p1-c11">Chapter Eleven</a></p>
<p class="toc2"><a href="#/OEBPS/p1c12.htm" id="p1-c12">Chapter Twelve</a></p>
<p class="toc2"><a href="#/OEBPS/p1c13.htm" id="p1-c13">Chapter Thirteen</a></p>
<p class="toc2"><a href="#/OEBPS/p1c14.htm" id="p1-c14">Chapter Fourteen</a></p>
<p class="toc2"><a href="#/OEBPS/p1c15.htm" id="p1-c15">Chapter Fifteen</a></p>
<p class="toc2"><a href="#/OEBPS/p1c16.htm" id="p1-c16">Chapter Sixteen</a></p>
<p class="toc2"><a href="#/OEBPS/p1c17.htm" id="p1-c17">Chapter Seventeen</a></p>
<p class="toc2"><a href="#/OEBPS/p1c18.htm" id="p1-c18">Chapter Eighteen</a></p>
<p class="toc2"><a href="#/OEBPS/p1c19.htm" id="p1-c19">Chapter Nineteen</a></p>
<p class="toc2"><a href="#/OEBPS/p1c20.htm" id="p1-c20">Chapter Twenty</a></p>
<p class="toc2"><a href="#/OEBPS/p1c21.htm" id="p1-c21">Chapter Twenty-One</a></p>
<p class="toc2"><a href="#/OEBPS/p1epi.htm" id="p1-epi">Epilogue</a></p>
<p class="toc1"><a href="#/OEBPS/p2tp.htm" id="p2-tp">Union Jack</a></p>
<p class="toc2"><a href="#/OEBPS/p2note.htm" id="p2-note">Note to Readers</a></p>
<p class="toc2"><a href="#/OEBPS/p2ded.htm">Dedication</a></p>
<p class="toc2"><a href="#/OEBPS/p2pro.htm" id="p2-pro">Prologue</a></p>
<p class="toc2"><a href="#/OEBPS/p2p1.htm" id="p2-p1">Part I: Blackpool, April 1984</a></p>
<p class="toc4"><a href="#/OEBPS/p2c01.htm" id="p2-c01">Chapter One</a></p>
<p class="toc4"><a href="#/OEBPS/p2c02.htm" id="p2-c02">Chapter Two</a></p>
<p class="toc4"><a href="#/OEBPS/p2c03.htm" id="p2-c03">Chapter Three</a></p>
<p class="toc4"><a href="#/OEBPS/p2c04.htm" id="p2-c04">Chapter Four</a></p>
<p class="toc2"><a href="#/OEBPS/p3p2.htm" id="p3-p2">Part II: Sheffield, April 1993</a></p>
<p class="toc4"><a href="#/OEBPS/p3c01.htm" id="p3-c01">Chapter One</a></p>
<p class="toc4"><a href="#/OEBPS/p3c02.htm" id="p3-c02">Chapter Two</a></p>
<p class="toc4"><a href="#/OEBPS/p3c03.htm" id="p3-c03">Chapter Three</a></p>
<p class="toc4"><a href="#/OEBPS/p3c04.htm" id="p3-c04">Chapter Four</a></p>
<p class="toc4"><a href="#/OEBPS/p3c05.htm" id="p3-c05">Chapter Five</a></p>
<p class="toc4"><a href="#/OEBPS/p3c06.htm" id="p3-c06">Chapter Six</a></p>
<p class="toc4"><a href="#/OEBPS/p3c07.htm" id="p3-c07">Chapter Seven</a></p>
<p class="toc4"><a href="#/OEBPS/p3c08.htm" id="p3-c08">Chapter Eight</a></p>
<p class="toc4"><a href="#/OEBPS/p3c09.htm" id="p3-c09">Chapter Nine</a></p>
<p class="toc4"><a href="#/OEBPS/p3c10.htm" id="p3-c10">Chapter Ten</a></p>
<p class="toc4"><a href="#/OEBPS/p3c11.htm" id="p3-c11">Chapter Eleven</a></p>
<p class="toc4"><a href="#/OEBPS/p3c12.htm" id="p3-c12">Chapter Twelve</a></p>
<p class="toc4"><a href="#/OEBPS/p3c13.htm" id="p3-c13">Chapter Thirteen</a></p>
<p class="toc4"><a href="#/OEBPS/p3c14.htm" id="p3-c14">Chapter Fourteen</a></p>
<p class="toc4"><a href="#/OEBPS/p3c15.htm" id="p3-c15">Chapter Fifteen</a></p>
<p class="toc4"><a href="#/OEBPS/p3c16.htm" id="p3-c16">Chapter Sixteen</a></p>
<p class="toc4"><a href="#/OEBPS/p3c17.htm" id="p3-c17">Chapter Seventeen</a></p>
<p class="toc2"><a href="#/OEBPS/p3epi.htm" id="p3-epi">Epilogue</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/back.htm">Back Cover</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4b0a58b5